export enum ENV {
  LOCAL = 'local',
  PRODUCTION = 'production',
  STAGING = 'staging',
  PR_PREVIEW = 'pr-preview',
}
